/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Fix_ReadmeInputs */

const en_rd_fix_readme = /** @type {(inputs: Rd_Fix_ReadmeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Put the install and run commands in the README so an agent can boot the project unaided.`)
};

const id_rd_fix_readme = /** @type {(inputs: Rd_Fix_ReadmeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taruh perintah install dan run di README supaya agent bisa menjalankan proyek tanpa bertanya.`)
};

/**
* | output |
* | --- |
* | "Put the install and run commands in the README so an agent can boot the project unaided." |
*
* @param {Rd_Fix_ReadmeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_fix_readme = /** @type {((inputs?: Rd_Fix_ReadmeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Fix_ReadmeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_fix_readme(inputs)
	return en_rd_fix_readme(inputs)
});